import React from 'react'
import FormatCurrency from 'components/Common/FormatCurrency'
import Pill from 'components/Luxkit/Pill'
import Caption from 'components/Luxkit/Typography/Caption'
import Group from 'components/utils/Group'
import TextButton from 'components/Luxkit/Button/TextButton'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { ValueWrapper } from 'components/Common/OfferPricing/styles'
import useCheapestOfTourV2Offer from 'hooks/TourV2/useCheapestOfTourV2Offer'
import useTourV2PurchasableOptionDetails from 'hooks/TourV2/useTourV2PurchasableOptionDetails'
import useTourV2VariationDetails from 'hooks/TourV2/useTourV2VariationDetails'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import PriceRowTaxesAndFees from 'components/Luxkit/PricePoints/PriceRowTaxesAndFees'

interface Props {
  offer: Tours.V2Offer | Tours.V2OfferSummary;
  className?: string;
}

function TourV2PriceDetails(props: Props) {
  const { offer } = props

  const {
    cheapestPurchasableOption,
    cheapestVariation,
  } = useCheapestOfTourV2Offer(offer)

  const {
    durationInDaysCount,
  } = useTourV2VariationDetails(cheapestVariation)

  const {
    pricePerPerson,
    roomTypeName,
    valuedAt,
  } = useTourV2PurchasableOptionDetails(cheapestPurchasableOption) || {}

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
      <div>
        {pricePerPerson && <>
          <PriceRowPriceCaption>{durationInDaysCount} from</PriceRowPriceCaption>
          <PriceRowPrice size="L" price={pricePerPerson} saleUnit="person" taxesAndFees="inclusive" />
        </>}
        <PriceRowTaxesAndFees taxesAndFees="inclusive" />
        {valuedAt &&
          <ValueWrapper variant="large" weight="bold" colour="neutral-one">
            <span data-testid="value-box">
              Valued up to <FormatCurrency value={Math.ceil(valuedAt.price)} />
            </span>
            <Pill kind="primary" variant="success">-{valuedAt.savingPercentage}%</Pill>
          </ValueWrapper>
          }
        <Caption variant="medium" colour="neutral-three">
          {roomTypeName}
        </Caption>
      </div>
      <CSSBreakpoint min="desktop">
        <TextButton kind="primary" nonInteractable>
          View
        </TextButton>
      </CSSBreakpoint>
    </Group>
  )
}

export default TourV2PriceDetails
